import * as type from './accountSettingsActionTypes';

// GENERAL ACTIONS
export const getAllRates = () => ({
  type: type.GET_ALL_RATES,
});

export const setAllRates = (rates) => ({
  type: type.SET_ALL_RATES,
  rates,
});

export const loadPossibleCyclesForUser = (user) => ({
  type: type.LOAD_POSSIBLE_CYCLES_FOR_USER,
  user,
});
export const cyclesForUpdateExamAction = (rate, rank, dutyState) => ({
  type: type.POSSIBLE_CYCLES_FOR_UPDATE_EXAM,
  rate,
  rank,
  dutyState,
});

export const setPossibleCyclesForUser = (cycles) => ({
  type: type.SET_POSSIBLE_CYCLES_FOR_USER,
  cycles,
});

export const setPossibleCyclesForUpdateExam = (cycles) => ({
  type: type.SET_POSSIBLE_CYCLES_FOR_UPDATE_EXAM,
  cycles,
});

// THESE ARE USED TO SWITCH BETWEEN PFE AND SKT
export const setSwitchPfeSktWaiting = (value) => ({
  type: type.SWITCH_PFE_SKT_WAITING,
  value,
});

export const setSwitchPfeSktAction = (value) => ({
  type: type.SWITCH_PFE_SKT,
  value,
});
export const setSwitchPfeSktMessage = (message) => ({
  type: type.SWITCH_PFE_SKT_MESSAGE,
  message,
});
export const setSwitchPfeSktValue = (value) => ({
  type: type.SWITCH_PFE_SKT_VALUE,
  value,
});

// MY PROFILE ACTIONS

export const updateUsername = (username) => ({
  type: type.UPDATE_USERNAME,
  username,
});

export const updatePersonalData = (personalData) => ({
  type: type.UPDATE_PERSONAL_DATA,
  personalData,
});

export const updateTimezone = (timezone) => ({
  type: type.UPDATE_TIMEZONE,
  timezone,
});

export const updateFlashcardAction = (payload) => ({
  type: type.UPDATE_FLASHCARD_ONLY,
  payload,
});

export const updateProfilePrivacy = (privacy) => ({
  type: type.UPDATE_PROFILE_PRIVACY,
  privacy,
});

export const setUpdateCycleWaiting = (value) => ({
  type: type.SET_UPDATE_CYCLE_WAITING,
  value,
});

export const setUpdateUsernameWaiting = (value) => ({
  type: type.SET_UPDATE_USERNAME_WAITING,
  value,
});

export const updateEmail = (email) => ({
  type: type.UPDATE_EMAIL,
  email,
});

export const setUpdateTimezoneWaiting = (value) => ({
  type: type.SET_UPDATE_TIMEZONE_WAITING,
  value,
});

export const updateRate = (rate) => ({
  type: type.UPDATE_RATE,
  rate,
});

export const setUpdateProfilePrivacyWaiting = (value) => ({
  type: type.SET_UPDATE_PROFILE_PRIVACY_WAITING,
  value,
});

export const setFlashcardOnlyWaiting = (value) => ({
  type: type.SET_FLASHCARD_ONLY_WAITING,
  value,
});

export const setFlashcardOnlyAction = (value) => ({
  type: type.SET_FLASHCARD_ONLY,
  value,
});

export const updateRatingExam = (id, rate, rank, dutyState, cycleSelected) => ({
  type: type.UPDATE_RATING_EXAM,
  id,
  rate,
  rank,
  dutyState,
  cycleSelected,
});

export const updatePassword = (oldPassword, newPassword) => ({
  type: type.UPDATE_PASSWORD,
  oldPassword,
  newPassword,
});

export const setUploadingImageWaiting = (value) => ({
  type: type.SET_UPLOADING_IMAGE_WAITING,
  value,
});

export const setUpdatePasswordWaiting = (value) => ({
  type: type.SET_UPDATE_PASSWORD_WAITING,
  value,
});

export const setUpdatePasswordMessage = (message) => ({
  type: type.SET_UPDATE_PASSWORD_MESSAGE,
  message,
});

export const setUpdateRateWaiting = (value) => ({
  type: type.SET_UPDATE_RATE_WAITING,
  value,
});

export const setUploadImageMessage = (message) => ({
  type: type.UPLOAD_IMAGE_MESSAGE,
  message,
});

export const setUpdateRateMessage = (message) => ({
  type: type.SET_UPDATE_RATE_MESSAGE,
  message,
});

export const setUpdateEmailWaiting = (value) => ({
  type: type.SET_UPDATE_EMAIL_WAITING,
  value,
});

export const setUpdateEmailMessage = (message) => ({
  type: type.SET_UPDATE_EMAIL_MESSAGE,
  message,
});

export const setUpdateUsernameMessage = (message) => ({
  type: type.SET_UPDATE_USERNAME_MESSAGE,
  message,
});

export const setUpdatePersonalDataMessage = (message) => ({
  type: type.SET_UPDATE_PERSONAL_DATA_MESSAGE,
  message,
});

export const setUpdateTimezoneMessage = (message) => ({
  type: type.SET_UPDATE_TIMEZONE_MESSAGE,
  message,
});

export const setUpdateProfilePrivacyMessage = (message) => ({
  type: type.SET_UPDATE_PROFILE_PRIVACY_MESSAGE,
  message,
});

export const setFlashcardOnlyMessage = (message) => ({
  type: type.SET_FLASHCARD_ONLY_MESSAGE,
  message,
});

export const setUploadImageSuccess = (value) => ({
  type: type.SET_UPLOAD_IMAGE_SUCCES,
  value,
});

export const uploadProfileImage = (imgFile) => ({
  type: type.UPLOAD_PROFILE_IMAGE,
  imgFile,
});

export const setUpdateRatingExamSuccess = (value) => ({
  type: type.SET_UPDATE_RATING_EXAM_SUCCESS,
  value,
});

export const setUpdateRatingExamWaiting = (value) => ({
  type: type.SET_UPDATE_RATING_EXAM_WAITING,
  value,
});

export const setUpdateRatingExamMessage = (message) => ({
  type: type.SET_UPDATE_RATING_EXAM_MESSAGE,
  message,
});

// MANAGE SUBSCRIPTION ACTIONS
export const loadUserSubscription = () => ({
  type: type.LOAD_USER_SUBSCRIPTION,
});

export const editPaymentDetails = (subscriptionId, details) => ({
  type: type.EDIT_PAYMENT_DETAILS,
  subscriptionId,
  details,
});

export const setEditPaymentDetailsWaiting = (value) => ({
  type: type.SET_EDIT_PAYMENT_DETAILS_WAITING,
  value,
});

export const setEditPaymentDetailsSuccess = (value) => ({
  type: type.SET_EDIT_PAYMENT_DETAILS_SUCCESS,
  value,
});

export const setEditPaymentDetailsMessage = (message) => ({
  type: type.SET_EDIT_PAYMENT_DETAILS_MESSAGE,
  message,
});

export const setCustomerMessage = (message) => ({
  type: type.SET_CUSTOMER_MESSAGE,
  message,
});

export const setCustomerSiteMockUp = (customer) => ({
  type: type.SET_CUSTOMER_SITE_MOCK_UP,
  customer,
});

export const setUserSubscription = (subscription) => ({
  type: type.SET_USER_SUBSCRIPTION,
  subscription,
});

export const setLoadingSubscription = (value) => ({
  type: type.SET_LOADING_SUBSCRIPTION,
  value,
});

// DISABLED QUESTIONS ACTIONS

export const resetAllDisabledQuestions = () => ({
  type: type.RESET_ALL_DISABLED_QUESTIONS,
});

export const getDisabledQuestions = (limit, skip) => ({
  type: type.GET_DISABLED_QUESTIONS,
  limit,
  skip,
});

export const getFavoriteQuestions = (limit, skip) => ({
  type: type.GET_FAVORITE_QUESTIONS,
  limit,
  skip,
});

export const getAllFavoriteQuestions = () => ({
  type: type.GET_ALL_FAVORITE_QUESTIONS,
});

export const getSubmittedQuestions = () => ({
  type: type.GET_SUBMITTED_QUESTIONS,
});

export const removeFavoriteQuestions = (userId, questionsId) => ({
  type: type.REMOVE_FAVORITE_QUESTIONS,
  userId,
  questionsId,
});
export const removeAllFavoriteQuestions = () => ({
  type: type.REMOVE_ALL_FAVORITE_QUESTIONS,
});

export const resetDisabledIndividualQuestion = (questionId) => ({
  type: type.RESET_DISABLED_INDIVIDUAL_QUESTION,
  questionId,
});

export const isLoadingResetAllQuestions = (isLoading) => ({
  type: type.IS_LOADING_RESET_ALL_DISABLED_QUESTIONS,
  isLoading,
});

export const isLoadingResetIndividualQuestion = (isLoading) => ({
  type: type.IS_LOADING_RESET_DISABLED_INDIVIDUAL_QUESTION,
  isLoading,
});

export const isLoadingGetDisabledlQuestions = (isLoading) => ({
  type: type.IS_LOADING_GET_DISABLED_QUESTIONS,
  isLoading,
});
export const loadingRemoveQuestions = (isLoading) => ({
  type: type.LOADING_REMOVE_FAVORITE_QUESTIONS,
  isLoading,
});
export const loadingGetFavoriteQuestions = (isLoading) => ({
  type: type.LOADING_GET_FAVORITE_QUESTIONS,
  isLoading,
});

export const setLoadingSubmittedQuestions = (isLoading) => ({
  type: type.SET_LOADING_SUBMITTED_QUESTIONS,
  isLoading,
});

export const successResetAllQuestions = (success) => ({
  type: type.SUCCESS_RESET_ALL_DISABLED_QUESTIONS,
  success,
});

export const successResetIndividualQuestion = (success) => ({
  type: type.SUCCESS_RESET_DISABLED_INDIVIDUAL_QUESTION,
  success,
});

export const successGetDisabledlQuestions = (success) => ({
  type: type.SUCCESS_GET_DISABLED_QUESTIONS,
  success,
});

export const setDisabledQuestions = (questions) => ({
  type: type.SET_DISABLED_QUESTIONS,
  questions,
});

export const setFavoriteQuestions = (questions) => ({
  type: type.SET_FAVORITE_QUESTIONS,
  questions,
});

export const setRemoveFavoriteQuestions = (questionId) => ({
  type: type.REMOVE_FAVORITE_QUESTION,
  questionId,
});

export const setAllFavoriteQuestions = (questions) => ({
  type: type.SET_ALL_FAVORITE_QUESTIONS,
  questions,
});

export const setSubmittedQuestions = (questions) => ({
  type: type.SET_SUBMITTED_QUESTIONS,
  questions,
});

export const setDisabledQuestionsCount = (count) => ({
  type: type.SET_DISABLED_QUESTIONS_COUNT,
  count,
});

export const setFavoriteQuestionsCount = (count) => ({
  type: type.SET_FAVORIE_QUESTIONS_COUNT,
  count,
});

export const removeQuestionFromList = (questionId, newCount) => ({
  type: type.REMOVE_QUESTION_FROM_LIST,
  questionId,
  newCount,
});

export const resetDisabledQuestionObject = () => ({
  type: type.RESET_DISABLED_QUESTIONS_OBJECT,
});

export const resetFavoriteQuestionObject = () => ({
  type: type.RESET_FAVORITE_QUESTIONS_OBJECT,
});
// NOTIFICATION PREFERENCES ACTIONS

export const getNotificationPreferences = () => ({
  type: type.GET_NOTIFICATION_PREFERENCES,
});

export const sendNotificationPreferences = (parameter, value) => ({
  type: type.SEND_NOTIFICATION_PREFERENCES,
  parameter,
  value,
});

export const loadingNotificationPreferences = (isLoading) => ({
  type: type.LOADING_PREFERENCES,
  isLoading,
});

export const loadingCustomer = (isLoading) => ({
  type: type.LOADING_CUSTOMER_SITE,
  isLoading,
});

export const successNotificationPreferences = (isSuccess) => ({
  type: type.SUCCESS_PREFERENCES,
  isSuccess,
});

export const setSpecificNotificationPreference = (preference) => ({
  type: type.SET_SPECIFIC_NOTIFICATION_PREFERENCE,
  preference,
});

export const setNotificationPreferences = (preferences) => ({
  type: type.SET_NOTIFICATION_PREFERENCES,
  preferences,
});

export const errorNotificationPreferences = (isError) => ({
  type: type.ERROR_PREFERENCES,
  isError,
});

// ACTIVATE RECEIVE QUESTIONS NOTIFICATIONS FROM COMPLETE FLASH CARD
export const activateReceiveQuestionsNotification = (active, description) => ({
  type: type.ACTIVATE_RECEIVE_QUESTIONS_NOTIFICATION,
  active,
  description,
});

export const setQuestionNotification = (id, idType) => ({
  type: type.SET_QUESTION_NOTIFICATION,
  id,
  idType,
});

// CUSTOMER SITE MOCK-UP
export const customerSiteMockUpAction = (customer) => ({
  type: type.CUSTOMER_SITE,
  customer,
});

export const getCustomerSiteMockUpAction = (userId) => ({
  type: type.GET_CUSTOMER_SITE_MOCK_UP,
  userId,
});

// APPLY COUPON USER
export const applyCouponUserAction = (coupon) => ({
  type: type.APPLY_COUPON_USER,
  coupon,
});

export const getLastCouponUserAction = () => ({
  type: type.GET_LAST_COUPON_USER,
});

export const setLastCouponUser = (coupon) => ({
  type: type.SET_LAST_COUPON_USER,
  coupon,
});

export const setApplyCouponMessage = (message) => ({
  type: type.SET_APPLY_COUPON_MESSAGE,
  message,
});

export const applyCouponLoading = (status) => ({
  type: type.LOAD_APPLY_COUPON,
  status,
});

// Qual for daily quiz
export const getAvailableQualForDailyQuiz = () => ({
  type: type.GET_AVAILABLE_QUALS_FOR_DAILY_QUIZ,
});

export const setAvailableQualForDailyQuiz = (quals) => ({
  type: type.SET_AVAILABLE_QUALS_FOR_DAILY_QUIZ,
  quals,
});

export const setFlashSectionChoose = (value) => ({
  type: type.SET_FLASH_SECTION_CHOOSE,
  value,
});

export const setStudySpeedSettings = (option) => ({
  type: type.SET_STUDY_SPEED_SETTINGS,
  option,
});

export const setStudySpeedSettingsMessage = (message) => ({
  type: type.SET_STUDY_SPEED_SETTINGS_MESSAGE,
  message,
});

export const setIsLoadingStudySpeedSettings = (status) => ({
  type: type.SET_IS_LOADING_STUDY_SPEED_SETTINGS,
  status,
});

// Custom Sync (mobile app sync settings)
export const getCustomSync = () => ({
  type: type.GET_CUSTOM_SYNC,
});
export const setCustomSync = (customSync) => ({
  type: type.SET_CUSTOM_SYNC,
  customSync,
});
export const updateCustomSync = (customSync) => ({
  type: type.UPDATE_CUSTOM_SYNC,
  customSync,
});
export const setCustomSyncMessage = (message) => ({
  type: type.SET_CUSTOM_SYNC_MESSAGE,
  message,
});
export const setIsLoadingCustomSync = (status) => ({
  type: type.SET_IS_LOADING_CUSTOM_SYNC,
  status,
});

export const setIsLoadingCustomSyncData = (status) => ({
  type: type.SET_IS_LOADING_CUSTOM_SYNC_DATA,
  status,
});
